import authenticationHelper from "@/AuthenticationHelper";
import { useEffect, useRef } from "react"


const useAuthenticationHelper = (listener?: () => void) => {

    const listenerRef = useRef<(() => void) | undefined>(listener);

    listenerRef.current = listener;

    useEffect(() => {
        const unsubscribe = authenticationHelper.subscribe(() => {
            listenerRef.current?.();
        });

        return () => {
            unsubscribe();
        }
    }, [listenerRef]);

}

export default useAuthenticationHelper;